import { render } from "./QrPromptpay.vue?vue&type=template&id=ec9b4222"
import script from "./QrPromptpay.vue?vue&type=script&lang=js"
export * from "./QrPromptpay.vue?vue&type=script&lang=js"
script.render = render

export default script